var React = require('react');

function StarsInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_225_2024)","key":0},React.createElement("path",{"d":"M3 1V5M1 3H5M4 15V19M2 17H6M11 1L13.2857 7.85714L19 10L13.2857 12.1429L11 19L8.71429 12.1429L3 10L8.71429 7.85714L11 1Z","stroke":"#69D994","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_225_2024"},React.createElement("rect",{"width":"20","height":"20","fill":"white"})))]);
}

StarsInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = StarsInline;

StarsInline.default = StarsInline;
